<!-- 推送服务 -->
<template>
  <div class="shell">
    <div class="ruleListPage" v-if="!judeStatus">
      <div class="functionDesc">
        <h2 class="title">智能推送</h2>
        <p>
          针对48小时活跃粉丝提前设置好内容，当粉丝触发发送规则后，立即推送，及时转化粉丝，实现精细化运营
        </p>
        <div class="imgBox"></div>
        <div
          class="createRightNow"
          @click="$router.push('smartHome?present=1')"
        >
          立即创建
        </div>
      </div>
      <!---->
      <!---->
    </div>
    <!-- 有数据的情况展示列表 -->
    <div class="dataList" v-else>
      <div class="top">
        <div class="topTile">智能推送</div>
        <div class="secondTitle">
          <div>
            针对48小时活跃粉丝提前设置好内容，当粉丝触发发送规则后，立即推送，及时转化粉丝，实现精细化运营。
          </div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="$router.push('smartHome?present=1')"
          >
            立即创建
          </el-button>
        </div>
      </div>
      <div class="list">
        <el-form
          ref="form"
          :model="form"
          label-width="120px"
          label-position="left"
          :inline="true"
        >
          <el-form-item label="发送完成时间">
            <el-date-picker
              v-model="form.data"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              format="yyyy 年 MM 月 dd 日"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="initData" size="small" icon="el-icon-search"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <el-table :data="listData" style="width: 99%" max-height="500px">
          <el-table-column prop="index" label="编号" width="180">
          </el-table-column>
          <el-table-column prop="name" label="规则名称"> </el-table-column>
          <el-table-column prop="sendData" label="推送时间"> </el-table-column>

          <!-- <el-table-column prop="create_ime" label="创建时间" width="180">
          </el-table-column>
          <el-table-column prop="num" label="发送总人数"> </el-table-column> -->
          <!-- <el-table-column prop="is_status" label="发送状态"> </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="changeData(1, scope.row.id)"
                >编辑</el-button
              >
              <el-button type="text" @click="changeData(0, scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { smartRuleList, smartRuleDel } from "@/api/push";
import time from "@/utils/time";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      total: 0,
      listData: [],
      form: {
        name: "",
        data: ""
      },
      judeStatus: false,
      page: 1
    };
  },

  components: {},
  mounted() {
    this.initData();
    this.jude();
  },
  methods: {
    // 操作
    changeData(type, id) {
      if (type == 0) {
        let data = {
          token: this.token,
          app_id: this.app_id,
          rule_id: id
        };
        this.$confirm("确定要删除该条推送记录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            smartRuleDel(data).then(res => {
              if (res.code == 200) this.$message.success("删除成功！！");
              this.reload();
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消开启"
            });
          });
      } else {
        this.$router.push({ name: "smartHome", query: { jude: 1, idJ: id } });
      }
    },
    handleCurrentChange(p) {
      this.page = p;
      this.initData();
    },
    initData() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      //时间查询
      if (this.form.data.length > 0) {
        data.start_time = this.form.data[0];
        data.end_time = this.form.data[1];
      }
      smartRuleList(data).then(res => {
        if (res.code == 200) {
          this.listData = res.data.data;
          this.total = res.data.total;
          this.page = res.data.current_page;
          this.listData.forEach((item, c_index) => {
            item.sendData = "立即发送";
            if (item.send_time == 2) {
              let obj = JSON.parse(item.wait_time);

              item.sendData = "等待" + obj.hour + "小时" + obj.minute + "分钟";
              console.log("时间", obj, item.sendData);
            } else if (item.send_time == 3) {
              if (item.timing_time.everyday) {
                item.sendData = "每日" + item.timing_time.everyday;
              } else {
                item.sendData = "周";
              }
            }
            item.createTime = time.setTime(item.create_time);

            item.index = c_index + 1;
          });
        }
      });
    },
    // 判断页面展示
    jude() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      smartRuleList(data).then(res => {
        if (res.code == 200) {
          this.judeStatus = res.data.total != 0 ? true : false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.shell {
  width: 100%;
  height: 100%;
  // 数据列表展示
  .dataList {
    width: 100%;
    .top {
      padding: 40px 20px 0;
      .topTile {
        font-size: 16px;
      }
      .secondTitle {
        color: #979ba0;
        font-size: 14px;
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        border-bottom: 1px solid #eee;
      }
    }
    .list {
      padding-top: 16px;
    }
  }
  .ruleListPage {
    width: 100%;
  }
  .ruleListPage .functionDesc {
    text-align: center;
  }

  .ruleListPage .functionDesc .title {
    font-size: 24px;
    color: #2f3543;
    margin-top: 26px;
    margin-bottom: 24px;
  }

  .ruleListPage .functionDesc .imgBox {
    width: 100%;
    height: 506px;
    background: url("../../../../../../../../public/img/intelligentSend.png")
      no-repeat;
    margin: 72px auto 0;
    background-position: center center;
    background-size: contain;
  }

  .ruleListPage .functionDesc .createRightNow {
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(#1fdeda),
      to(#2edf65)
    );
    background: linear-gradient(90deg, #1fdeda, #2edf65);
    -webkit-box-shadow: 0 4px 14px 0 rgba(0, 184, 181, 0.3);
    box-shadow: 0 4px 14px 0 rgba(0, 184, 181, 0.3);
    border-radius: 20px;
    color: #fff;
    cursor: pointer;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    text-align: center;
    margin: 30px auto 26px;
    font-size: 16px;
  }

  .ruleListPage .functionDesc .createRightNow:hover {
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(#00d2d5),
      to(#00d86b)
    );
    background: linear-gradient(90deg, #00d2d5, #00d86b);
  }
}
</style>
